export function debounce(func, wait = 100) {
  let timeout;
  
  return function executedFunction(...args) {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      clearTimeout(timeout);
      func(...args);
    }, wait);
  };
}
